import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { NotificationPreferenceList } from "@msuite/utils/types";
import { client } from "@/hono";

/** What the query caches: the rows and whether the account has an address. */
export interface NotificationPreferencesData {
	preferences: NotificationPreferenceList;
	hasEmail: boolean;
}

/**
 * The signed-in person's own notification preferences: one row per catalogue kind with its push
 * and its mail on, off or not offered, and whether their account has an address mail can reach.
 *
 * Ungated like its endpoint — every person may read their own choices.
 */
export function useNotificationPreferences() {
	/** Query */
	const query = useQuery<NotificationPreferencesData>({
		queryKey: ["notification-preferences"],
		queryFn: async () => {
			const response = await client.users["notification-preferences"].$get();
			const data = await responseHandler(response);
			return { preferences: data.preferences, hasEmail: data.hasEmail };
		},
	});

	/** Return */
	return {
		...query,
		preferences: query.data?.preferences,
		hasEmail: query.data?.hasEmail ?? true,
	};
}
